/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { dropTask } from 'ember-concurrency';
import { hash } from 'rsvp';
import LayoutModel from 'cio/models/layout';
import ActionModel from 'cio/models/action';
import NewsletterModel from 'cio/models/newsletter';
import TransactionalMessageModel from 'cio/models/transactional-message';
import TemplateModel from 'cio/models/template';
import CampaignModel from 'cio/models/campaign';

interface LayoutUsageTableArgs {
  layoutItem: LayoutModel;
}

export type LayoutUsageTableRow = {
  description: string;
  icon: string;
  route: string;
} & (
  | {
      type: 'transactional-message';
      item: TransactionalMessageModel;
      actions: TemplateModel[];
    }
  | {
      type: 'newsletter';
      item: NewsletterModel;
      actions: TemplateModel[];
    }
  | {
      type: 'campaign';
      item: CampaignModel;
      actions: ActionModel[];
    }
);

export default class LayoutUsageTable extends Component<LayoutUsageTableArgs> {
  prepareRows = dropTask(async () => {
    let { layoutItem: layout } = this.args;

    let {
      actions,
      newsletters,
      transactionalMessages,
    }: {
      actions: ActionModel[];
      newsletters: NewsletterModel[];
      transactionalMessages: TransactionalMessageModel[];
    } = await hash({
      actions: layout.get('actions') as unknown as ActionModel[],
      newsletters: layout.get('newsletters') as unknown as NewsletterModel[],
      transactionalMessages: layout.get('transactionalMessages') as unknown as TransactionalMessageModel[],
    });

    let campaignRows = actions
      .reduce((rows, action) => {
        let campaignId = Number(action.belongsTo('campaign').id());
        if (isEmpty(rows[campaignId])) {
          let campaign = action.get('campaign');

          rows[campaignId] = {
            item: campaign,
            type: 'campaign',
            description: campaign.get('typeName'),
            icon: campaign.get('icon'),
            actions: [],
            route: 'campaigns.campaign.overview',
          };
        }

        let row = rows[campaignId];
        if (row.type === 'campaign') {
          row.actions.push(action);
        }

        return rows;
      }, [] as LayoutUsageTableRow[])
      .compact();

    let newsletterRows: LayoutUsageTableRow[] = newsletters.map((newsletter) => ({
      item: newsletter,
      type: 'newsletter',
      description: 'Newsletter',
      icon: 'newsletter',
      actions: newsletter.get('activeTemplates'),
      route: 'broadcasts.newsletter.index',
    }));

    let transactionalRows: LayoutUsageTableRow[] = transactionalMessages.map((message) => ({
      item: message,
      type: 'transactional-message',
      description: 'Transactional Message',
      icon: 'transactional-api',
      actions: message.templates,
      route: 'transactional.message',
    }));

    return _sortBy([...campaignRows, ...newsletterRows, ...transactionalRows], ['item.created']).reverse();
  });
}
